import { PublicTeamSchema } from "../../models/team.schema";

export const TeamControllerResponseSchema = {
  listPublicTeams: PublicTeamSchema.array(),

  getPublicTeam: PublicTeamSchema.nullable(),
};
